<template>
  <div id="about">
    <v-container grid-list-md text-xs-center class="section">
      <v-layout row wrap>
        <v-flex xs12 md12>
          <v-card flat tile class="lighten-1 text-xs-center">
            <v-card-text>
              <div class="display-1 font-weight-bold">关于迦南资本</div>
              <div class="subheading text-xs-left my-4"><span class="display-1">迦</span>南资本是专注于资产全球化配置与运营和深度海外生活体验。“迦南”的名字来自于圣经《出埃及记》中的迦南美地，一块“流着奶和蜜”的上帝应许之地。“迦南”代表着我们的期望，暨在资产配置大航海时代，为中国资本出海保驾护航，寻找最理想的居住地，做您享受海外生活领航员。</div>
              <div class="subheading text-xs-left my-4">公司业务包括海外资产配置、海外资产运营、海外生活体验三大板块，满足您的不同需求。</div>
              <div class="subheading text-xs-left my-4">迦南资本目前已在上海、香港、美国、澳洲、欧洲设有资产管理平台，其中迦南上海是首批注册于上海自贸区的资产管理公司，已于中国证券基金业协会备案，并拥有私募基金牌照，同时和各大移民机构保持长期合作。</div>
            </v-card-text>
          </v-card>
          <v-img class="wow fadeInUp" :src="require('../../public/images/about/2_1.png')" max-width="800" style="margin: 0 auto" />
          <!-- <video width="80%" controls>
            <source src="../../public/images/information.mp4" type="video/mp4">
          </> -->
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md text-xs-center class="section">
      <v-layout row wrap>
        <v-flex xs12 md12>
          <div class="display-1 font-weight-bold">董事长致辞</div>
        </v-flex>
        <v-flex xs12 md12 mb-4>
          <v-img :src="require('../../public/images/comma.png')" class="white--text my-4" max-height="50" max-width="50" />
          <div class="title my-4">迦南资本将以专业的精神为投资者服务，欢迎投资者参与到迦南资本的项目中来，共同分享海外地产投资的成果。</div>
        </v-flex>
        <v-flex xs12 md4 lg5 my-4 mr-4 ml-4>
          <div class="wow fadeInRight">
            <v-img :src="require('../../public/images/about/founder.png')" class="white--text my-4" height="390px" />
            <div class="subheading mt-3">创办人 <span class="title">李晓东</span></div>
          </div>
        </v-flex>
        <v-flex xs12 md7 lg6 my-4>
          <div class="subheading text-xs-left my-4 wow fadeInLeft"><span class="display-1">随</span>着中国经济改革的全面深化和提速，国内家庭财富的积累对于海外置业及全球资产配置的需求日益迫切；同时，全球经济一体化的发展使得人民币的可自由兑换即将成为可能。为了因应这样的发展趋势，2013年底，上海迦南资产管理有限公司（“迦南资本”）正式在上海自贸区注册成立，成为区内第一家专注于海外地产投资的房地产基金公司。 随着未来利率市场化，人民币国际化这两个进程节奏，迦南资本的控股股东——建银精瑞资本管理集团在海外投资积极部署。作为“自贸区战略”的重要布局，迦南资本专注于海外房地产投资的PE基金管理公司，主要涉及海外地产投资，包括住宅、商业、办公等传统业态，未来也会涉足养老、旅游、酒庄、农场等非传统地产业态。现在国内流动性泛滥，人民币升值的压力比较大，积极的开拓海外投资也符合国家的政策。我们地产PE跟开发商做海外投资是完全不同的——开发商可能是去外面买一块地做开发，在当地销售或吸引国内客户购买，而地产PE更多是把金融特色突出。第一我们会全球布局，为投资人重点挖掘价值洼地；第二，我们的基金会跟当地银行合作，成立合资公司，充分整合当地资源。这样的商业模式非常清晰，投资周期也能够控制，而最重要的是，不同于开发商海外投资是追求企业盈利，地产PE能够让国内投资人分享到投资成果。</div>
        </v-flex>
        <v-flex xs12 md12 my-4>
          <div class="display-1 font-weight-bold my-4">团队成员</div>
        </v-flex>
        <v-flex xs12 md4 my-4>
          <v-tooltip color="yellow darken-3" bottom>
            <div slot="activator" class="display-1">
              <v-avatar class="wow flipInY" :size="avatarSize" color="grey lighten-4">
                <img src="../../public/images/about/teamPage_4_1.png" alt="avatar">
              </v-avatar>
              <div class="title mt-3">李晓东</div>
              <div class="body-1">Founder</div>
            </div>
            <v-container>
              <span class="subheading">tooltip建银精瑞资本、迦南资本创始合伙人全国工商联房地产商会副会长，北京大学EMBA、北京大学房地产金融研究中心研究员、博士后导师。历任联华信托总裁、新希望集团金融事业部总经理，上市公司中国民生银行、中联建设、双鹤药业董事，东方基金管理公司、金鹰基金管理公司董事，方正证券独立董事。曾荣获“中国新锐金融人物”、“品牌中国十大房地产年度人物”、“中国房地产十大投资人”等荣誉。2008年联合全国工商联房地产商会、建银国际、华远地产等知名企事业单位创办建银精瑞资本，并将其打造成中国领先的房地产基金。连续多年蝉联“中国房地产基金十强”和“最佳GP管理团队”称号。2013年建银精瑞将海外投资业务分拆，设立迦南资本，2015年迦南资本荣获“海外地产投资最佳创新实践奖。</span>
            </v-container>
          </v-tooltip>
        </v-flex>
                <v-flex xs12 md4 my-4>
          <v-tooltip color="yellow darken-3" bottom>
            <div slot="activator" class="display-1">
              <v-avatar class="wow flipInY" :size="avatarSize" color="grey lighten-4">
                <img src="../../public/images/about/teamPage_4_3.png" alt="avatar">
              </v-avatar>
              <div class="title mt-3">Jason Liu</div>
              <div class="body-1">Vice President</div>
            </div>
            <v-container>
              <span class="subheading">加拿大籍华人，专注从事海外投资领域二十余年，对海外投资，移民，留学，私人银行，家族信托等拥有深刻认知，是欧洲马耳他MRVP永居移民法案的参与者之一，极擅长海外资产规划，房产投资和解决税务问题。主导编撰并出版《欧洲移居指南》、《马耳他教育白皮书》、《马耳他移民白皮书》等专业书籍。</span>
            </v-container>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md4 my-4>
          <v-tooltip color="yellow darken-3" bottom>
            <div slot="activator" class="display-1">
              <v-avatar class="wow flipInY" :size="avatarSize" color="grey lighten-4">
                <img src="../../public/images/about/teamPage_4_2.png" alt="avatar">
              </v-avatar>
              <div class="title mt-3">李若珺</div>
              <div class="body-1">Chief Financial Officer</div>
              <div class="body-1" style="margin: -20px">Chief Operating Officer</div>
            </div>
            <v-container>
              <span class="subheading">毕业于澳大利亚麦考瑞大学精算硕士专业，曾任职于建银精瑞综合管理部总监，财务总经理拥有近十年跨国财务管理经验，投资分析经验。</span>
            </v-container>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md4 my-4>
          <v-tooltip color="yellow darken-3" top>
            <div slot="activator" class="display-1">
              <v-avatar class="wow flipInY" :size="avatarSize" color="grey lighten-4">
                <img src="../../public/images/about/teamPage_4_4.png" alt="avatar">
              </v-avatar>
              <div class="title mt-3">惠无非</div>
              <div class="body-1">Managing Director-Canaan Eurpoe</div>
            </div>
            <v-container>
              <span class="subheading">西班牙ESIC商学院营销管理硕士，胡安卡洛斯国王大学企业管理硕士。曾任职于马士基西班牙、西班牙投资置业顾问集团有限公司。任职期间主要负责物流管理、客户关系、市场营销、移民产品设计、项目开发、项目管理、地产项目的改造与销售以及其他公司管理业务。</span>
            </v-container>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md4 my-4>
          <v-tooltip color="yellow darken-3" top>
            <div slot="activator" class="display-1">
              <v-avatar class="wow flipInY" :size="avatarSize" color="grey lighten-4">
                <img src="../../public/images/about/teamPage_4_5.png" alt="avatar">
              </v-avatar>
              <div class="title mt-3">张文鲲</div>
              <div class="body-1">Managing Director-Canaan Australia</div>
            </div>
            <v-container>
              <span class="subheading">澳大利亚莫纳什大学国际金融学硕士，墨尔本大学会计金融学学士。曾任职于全球连锁营销公司Appco Group、平安证券有限责任公司（深圳）、澳洲本土地产开发商Harman Global Holdings (Australia)。供职期间主要负责产品设计、市场营销、项目管理、IPO、再融资、M&A及澳洲各主要市场房地产项目投融资及管理业务。</span>
            </v-container>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md4 my-4>
          <v-tooltip color="yellow darken-3" top>
            <div slot="activator" class="display-1">
              <v-avatar class="wow flipInY" :size="avatarSize" color="grey lighten-4">
                <img src="../../public/images/about/teamPage_4_6.png" alt="avatar">
              </v-avatar>
              <div class="title mt-3">艾华夏</div>
              <div class="body-1">Managing Director-Canaan Travel</div>
            </div>
            <v-container>
              <span class="subheading">新西兰梅西大学金融学硕士，奥克兰大学会计及金融学学士。在从事旅游行业前，曾在上海陆家嘴的新加坡发展银行中国总部先后担任外汇交易员和总裁助理。于2014年开始专注高端定制旅行。现在他带领一支由前领馆高级官员，外籍华人和本土资深旅游业专家组成的团队。核心团队成员平均在海外生活超过十年，均毕业于当地名校，对于海外文化历史，风土人情，移民投资环境都有着深刻体会和独到见解，并涉及私人飞机、游艇、度假会所、猎场、酒庄、高尔夫球场等顶级旅游资源。</span>
            </v-container>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      avatarSize: '180px'
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  }
}
</script>